import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {
  DownloadPacketsFormData,
  FlightBriefingParams,
} from '../../../@types/FlightBriefing.type';

dayjs.extend(customParseFormat);

export type FormErrors = Partial<Record<keyof DownloadPacketsFormData, string>>;

/** Converts the dropdown value (MM/DD/YY) to the API format (YYYY-MM-DD). */
export const toApiDate = (date: string): string =>
  dayjs(date, 'MM/DD/YY', true).format('YYYY-MM-DD');

export const validateDownloadForm = (
  form: DownloadPacketsFormData,
): FormErrors => {
  const errors: FormErrors = {};
  if (!/^\d{1,4}$/.test(form.flightNumber.trim())) {
    errors.flightNumber = 'Enter a flight number (1-4 digits).';
  }
  if (!/^[A-Za-z]{3}$/.test(form.origin.trim())) {
    errors.origin = 'Enter a 3-letter origin station.';
  }
  if (!/^[A-Za-z]{3}$/.test(form.destination.trim())) {
    errors.destination = 'Enter a 3-letter destination station.';
  } else if (
    form.destination.trim().toUpperCase() === form.origin.trim().toUpperCase()
  ) {
    errors.destination = 'Destination must be different from origin.';
  }
  if (!dayjs(form.flightDate, 'MM/DD/YY', true).isValid()) {
    errors.flightDate = 'Select a flight date.';
  }
  return errors;
};

export const toFlightBriefingParams = (
  form: DownloadPacketsFormData,
): FlightBriefingParams => ({
  operatingAirline: form.airline,
  scheduledOperatingDateUTC: toApiDate(form.flightDate),
  flightNumber: form.flightNumber.trim(),
  origin: form.origin.trim().toUpperCase(),
  destination: form.destination.trim().toUpperCase(),
});
